import gql from 'graphql-tag';

export const VIRTUAL_TOURS_FRAGMENT = gql`
    fragment VIRTUAL_TOURS_FRAGMENT on ListingData {
        embeddedContent {
            videos {
                url
            }
            tours {
                url
            }
            links {
                url
            }
        }
    }
`;
